function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #707070;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_34931",
  "data-name": "Group 34931",
  transform: "translate(-664 -714)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Ellipse_272",
  "data-name": "Ellipse 272",
  className: "cls-1",
  d: "M14,3A11,11,0,0,0,6.222,21.778,11,11,0,1,0,21.778,6.222,10.928,10.928,0,0,0,14,3m0-3A14,14,0,1,1,0,14,14,14,0,0,1,14,0Z",
  transform: "translate(664 714)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_34930",
  "data-name": "Group 34930",
  transform: "translate(1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_36965",
  "data-name": "Path 36965",
  className: "cls-1",
  d: "M0,11.5A1.5,1.5,0,0,1-1.5,10V2.777A1.5,1.5,0,0,1,0,1.277a1.5,1.5,0,0,1,1.5,1.5V10A1.5,1.5,0,0,1,0,11.5Z",
  transform: "translate(677.5 719.223)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_273",
  "data-name": "Ellipse 273",
  className: "cls-1",
  cx: 1.5,
  cy: 1.5,
  r: 1.5,
  transform: "translate(676 732)"
})));

var SvgFailed = function SvgFailed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFailed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/failed.432a65e2.svg";
export { ForwardRef as ReactComponent };